export default "__VITE_ASSET__9d9a61f7__"